/* global num, t */
// ============================================================
// BANKAVSTEMMING — matchestatus
// ============================================================
// Bankflaten har allerede en status per linje (`getBankLineStatus`). Den sier
// hvor linjen staar i BEHANDLINGEN. Avstemmingen trenger noe annet: om linjen
// er koblet til en bokforing i det hele tatt, og hvis ikke — hvilken av sidene
// som mangler. Det er det denne fila oversetter til.
//
// Kategoriene er bevisst faerre enn i designutkastet. «Automatisk matchet» mot
// «manuelt matchet» krever at appen husker HVEM som koblet linjen, og det gjor
// den ikke. Da er én ærlig kategori bedre enn to oppdiktede.

// `label` er en getter: den oversettes når den leses (ved render), ikke når
// modulen lastes. Nøklene (`matchet`, `foreslatt` ...) er stabile id-er.
const BANK_RECON_MATCH = {
  matchet: { get label() { return t('rcb.match.matched', 'Matchet mot bokføring'); }, settled: true },
  foreslatt: { get label() { return t('rcb.match.suggested', 'Foreslått match'); }, settled: false },
  kontroll: { get label() { return t('rcb.match.review', 'Til manuell kontroll'); }, settled: false },
  umatchet_bank: { get label() { return t('rcb.match.unmatchedBank', 'Umatchet banktransaksjon'); }, settled: false },
  manuell: { get label() { return t('rcb.match.manual', 'Lagt til manuelt'); }, settled: false },
  utenfor: { get label() { return t('rcb.match.excluded', 'Holdt utenfor'); }, settled: true },
  uten_banktreff: { get label() { return t('rcb.match.noBankMatch', 'Bokføring uten banktreff'); }, settled: false },
};

// Rekkefolgen speiler `getBankLineStatus`: de statusene som sier noe om
// koblingen gaar foran de som bare sier hvor i behandlingen linjen staar.
const bankReconMatchOf = (status) => {
  if (status === 'avvik') return 'manuell';
  if (['privat', 'drift', 'ignorer'].includes(status)) return 'utenfor';
  if (status === 'kontroll') return 'kontroll';
  if (status === 'forslag') return 'foreslatt';
  if (['matchet', 'bokfort', 'godkjent'].includes(status)) return 'matchet';
  return 'umatchet_bank';
};

// Oppsummeringen som viser hvor stor del av perioden som faktisk er koblet.
// Bokforinger uten banktreff teller med: de er den andre halvdelen av samme
// sporsmaal, og aa utelate dem ville gitt en matchegrad som ser bedre ut enn
// virkeligheten.
const bankReconMatchSummary = ({ lines, transit }) => {
  const rows = [];
  const push = (key, entries) => {
    if (!entries.length) return;
    rows.push({
      key,
      label: BANK_RECON_MATCH[key].label,
      count: entries.length,
      amount: Math.round(entries.reduce((total, entry) => total + num(entry.amount), 0) * 100) / 100,
    });
  };
  for (const key of ['matchet', 'foreslatt', 'kontroll', 'umatchet_bank', 'manuell', 'utenfor']) {
    push(key, lines.filter((line) => line.match === key));
  }
  push('uten_banktreff', transit);

  const total = rows.reduce((sum, row) => sum + row.count, 0);
  const settled = rows
    .filter((row) => BANK_RECON_MATCH[row.key].settled)
    .reduce((sum, row) => sum + row.count, 0);
  return { rows, total, settled, pct: total ? Math.round((settled / total) * 100) : 0 };
};

Object.assign(window, { BANK_RECON_MATCH, bankReconMatchOf, bankReconMatchSummary });
